import { styled } from '@mui/material';

export const Separator = styled('li')`
  display: flex;
  align-items: center;
  margin: 0px 8px;
`;

export const ListItem = styled('li')``;

export const ListItemLink = styled('a')`
  text-decoration: none;
  color: ${(props) => props.theme.palette.text.primary};

  svg {
    margin-right: 5px;
  }
`;
